import { FIELD_PATHS } from '@funnels/constants';
import { AssetEntityIndex } from '@funnels/types';
import { validateNotFutureDate } from '@funnels/utils';

import { DatePickerInputField } from '../../../Fields';

interface DateOfPurchaseProps extends AssetEntityIndex {
  isOptional?: boolean;
  isDisabled?: boolean;
}

export const DateOfPurchase = ({ assetIndex, isOptional, isDisabled }: DateOfPurchaseProps) => (
  <DatePickerInputField
    hasDayField
    label="Date of purchase"
    subLabel="Enter the contract signing date"
    name={FIELD_PATHS.ASSET_CONTRACT_DATE(assetIndex)}
    isOptional={isOptional}
    isDisabled={isDisabled}
    validate={validateNotFutureDate(undefined, true)}
  />
);
